export default __webpack_public_path__ + "static/media/gelato_logo_white.be4f834d.svg";